
import React, { forwardRef, useState } from 'react';
import { useDispatch, useSelector} from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import * as icons from 'react-bootstrap-icons';
import CButton from 'Utils/Helpers/CButton';
import SelectComponent from 'Utils/Helpers/SelectComponent';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { get_byDate, get_byPatient, update_appointment_type } from 'http/components/AppointmentService';
import { SetAppointmentsData, SetPatientAppointmentsData } from 'Utils/Helpers/HandleApiData';
import { enqueueSnackbar } from 'notistack';
import ActionButton from 'Utils/Helpers/ActionButton';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AppointmentTypeEdit({ data, patient }) {
  const dispatch = useDispatch();
  const { appointmentTypes, dateSearch, current } = useSelector((state) => ({
      appointmentTypes: state.setting.appointmentTypes,
      dateSearch: state.setting.dateSearch,
      current: state.staff.current,
  }));
  const [type, setType] = useState(null);
  const [show, setShow] = useState(false);
  const setShowDialog = () => {
    setShow(true);
  }
  const handleClose= () => {
    setShow(false);
  }
  const onSelectChange = (e) => {
    setType(e);
  }
  const onFinish = async () => {
    if(type && type !== data.type) {
      dispatch(HandleLoading(true));
      const response = await update_appointment_type(data.id, type);
      if(response.status) {
        if(patient) {
          const response2 = await get_byPatient(patient);
          if(response2.status) {
            await dispatch(SetPatientAppointmentsData(response2.data))
          } else {
            dispatch(HandleLoading(false));
          }
        } else {
          const response2 = await get_byDate(dateSearch.date);
          if(response2.status) {
              await dispatch(SetAppointmentsData(response2.data))
          } else {
            dispatch(HandleLoading(false));
          }
        }
      } else {
        dispatch(HandleLoading(false));
      }
      setShow(false);
    } else {
      enqueueSnackbar('نوع انتخاب نشده است', {variant: 'warning'});
    }
  }
  return (
    <>
      <ActionButton
        icon={<icons.Pencil />}
        onClick={setShowDialog}
        disabled={!current[1][3]}
        hidden={!current[1][3]}
      />
      {
        show &&
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={'xs'}
          // TransitionProps={{onEnter: onEnter}}
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-appointment-edit"
        >
          <DialogTitle className='edit-mode'>
            {`ویرایش نوع`}
            <div className='close-btn' onClick={handleClose}>
              <icons.X/>
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-appointment-edit">
              <div className='flex-column-start-start my-2'>
                <span className='mb-2'>
                  شما میتوانید با استفاده از منو زیر نوع نوبت را تغییر دهید :
                </span>
                {
                  <SelectComponent
                    name={'app-type'}
                    icon={<icons.Fingerprint/>}
                    options={appointmentTypes}
                    selected={data.type}
                    onChange={onSelectChange}
                  />
                }
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <CButton
              text={'ذخیره تغییر نوع نوبت'}
              icon={<icons.Save2/>}
              onClick={onFinish}
            />
          </DialogActions>
        </Dialog>
      }
    </>
  );
}
